import React from 'react'
import Sectionbreak from './Sectionbreak'
import { services } from '../constants/services'
import { Link } from 'react-router-dom'
import AnimatedSection from './common/AnimatedSection'



function Services() {
  return (
    <AnimatedSection id="services" className="pt-10 pb-10 px-6 bg-white">
      <Sectionbreak
      title='Our'
      highlight='Services'
      description='We offer comprehensive services to meet the demands of modern construction, architecture, and property development.'
      />

      {/* Services Grid */}

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
      {services.map((service, index) => (
        <Link
          key={index}
          to={`/services/${service.slug}`}
          className="group bg-white rounded-2xl shadow-lg overflow-hidden 
            transition-all duration-300 
            hover:scale-[1.03] hover:shadow-xl
            flex flex-col
          "
        >
          {/* Image */}
          <img
            src={service.image}
            alt={service.title}
            className="h-48 w-full object-cover"
          />

          {/* Content */}
          <div className="p-6 flex flex-col flex-grow">
            <h3 className="text-lg font-semibold text-blue-950 mb-2 group-hover:text-teal-700 transition">
              {service.title}
            </h3>

            <p className="text-gray-600 text-base font-light mb-6">
              {service.description}
            </p>

            {/* CTA (visual only, still clickable as whole card) */}
            <div
              className="mt-auto inline-flex items-center justify-center px-5 py-2.5 
                text-sm font-normal text-teal-700 
                bg-teal-50/80 backdrop-blur 
                border border-teal-100 
                rounded-full w-36
                transition-all duration-300 ease-out
                group-hover:bg-teal-100 
                group-hover:text-teal-800
                group-hover:shadow-md 
                group-hover:-translate-y-0.5
              "
            >
              Learn More <span className="ml-2">→</span>
            </div>
          </div>
        </Link>
      ))}
    </div>

    </AnimatedSection>
  )
}

export default Services
